import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

import { ConfirmJobChargesPopupStyle } from "./style";

function ConfirmJobChargesPopup(props) {
  const classes = ConfirmJobChargesPopupStyle();
  const [scroll] = useState("body");
  return (
    <div className={classes.ConfirmWrapper}>
      <Dialog
        open={props.open}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "left" }}>Confirm invoice Re-generation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ textAlign: "left" }}>
            All job prices are updated.
            You can proceed to re-generate all draft invoices now, or finish
            this review and handle them manually later.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleConfirm}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            FINISH
          </Button>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="orange-btn primary-btn"
          >
            PROCEED
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ConfirmJobChargesPopup;
